/**
 * Created by nguyendx on 2017/09/28
 * -------------------------------
 */

import {Component, Injector, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {EvsProductService} from '../../../services/EvsProduct.service';
import {UploadService} from '../../../services/Upload.service';

declare var $: any;

@Component({
  selector: 'product-upload-excel',
  templateUrl: './product.excel.component.html',
  styleUrls: ['./product.css'],
  providers: [EvsProductService]
})

export class ProductExcelComponent implements OnInit {
  public productExcelForm: FormGroup;
  public product: any = {};
  public message: { class: string, content: string } = null;
  public titleFile: string = "Chọn file upload";
  public error: string = '';
  public files: any = null;

  constructor(public injector: Injector,
              public evsProductService: EvsProductService,
              public upload: UploadService) {
  }

  ngOnInit() {
  }

  onChange(event) {
    this.files = event.target.files;
    if (this.files.length > 0) {
      this.titleFile = this.files[0].name;
    } else {
      this.titleFile = 'Chọn file upload';
    }
  }

  submitForm(data) {
    console.log('submitForm');
    this.message = null;
    this.titleFile = "Chọn file upload";
    let objectData = {};

    if (this.files !== null && this.files.length > 0) {
      console.log('Upload file: ');
      var file = this.files[0];
      this.files = null;

      this.message = {
        class: "alert dark alert-success",
        content: "Call Upload file."
      };

      // this.upload.upload(file).then(
      //   (value: any) => {
      //     console.log('upload file: ', value);
      //   });
    } else {
      this.message = {
        class: "alert alert-danger",
        content: "Bạn chưa chọn file để Import."
      };
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/common/helper/evs/product/product.excel.component.ts